<template>
  <d-modal @close="handleClose" size="lg">
    <d-modal-header>
      <d-modal-title>
        {{ $t('order.evidencePopup.title') }} {{ evidenceData.updated_at }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
              <th scope="col" class="border-0 pl-4">{{ $t('order.evidencePopup.productName') }}</th>
              <th scope="col" class="border-0" style="width: 100px;">{{ $t('order.evidencePopup.amount') }}</th>
              <th scope="col" class="border-0" style="width: 300px;">{{ $t('order.evidencePopup.price') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(product, index) of evidenceData.products">
            <tr :key="'evidence-product-' + index">
                <td
                  :key="'evidence-product-col-1-' + index"
                  class="align-middle pl-4">
                    {{ product.product_name }}<br>
                    <small><strong>{{ $t('ui.code')}}:</strong> {{ product.product_code }}</small>
                </td>
                <td
                  :key="'evidence-product-col-2-' + index"
                  class="align-middle">
                    {{ product.quantity }} {{ $t('ui.piecesAbbr') }}
                </td>
                <td
                  :key="'evidence-product-col-3-' + index"
                  class="align-middle">
                    {{ product.price }} {{ currencySymbol }} {{ $t('ui.perUnit') }}
                </td>
            </tr>
            <tr
              v-for="(service, subindex) of servicesInProduct(product.order_product_id)"
              :key="'evidence-product-service-' + subindex">
                <td
                  :key="'evidence-product-service-col-1-' + subindex"
                  class="align-middle pl-4">
                    <div class="pl-4">
                      {{ service.service_name }}<br>
                      <small><strong>{{ $t('ui.code')}}:</strong> {{ service.service_code }}</small>
                    </div>
                </td>
                <td
                  :key="'evidence-product-service-col-2-' + subindex"
                  class="align-middle">
                    {{ service.quantity }} {{ $t('ui.piecesAbbr') }}
                </td>
                <td
                  :key="'evidence-product-service-col-3-' + subindex"
                  class="align-middle">
                    {{ service.price }} {{ currencySymbol }} {{ $t('ui.perUnit') }}<br>
                    {{ service.price_setup }} {{ currencySymbol }} ({{ $t('service.setup') }})<br>
                    {{ $t('service.fromHowManyPiecesThePriceIsMultiplied') }}: {{ service.content.price_multiple_from }} {{ $t('ui.piecesAbbr') }}
                </td>
            </tr>
          </template>
        </tbody>
      </table>

      <table
        v-if="globalServices.length"
        class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
              <th scope="col" class="border-0 pl-4">{{ $t('order.evidencePopup.serviceName') }}</th>
              <th scope="col" class="border-0" style="width: 100px;">{{ $t('order.evidencePopup.amount') }}</th>
              <th scope="col" class="border-0" style="width: 300px;">{{ $t('order.evidencePopup.price') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(service, index) of globalServices">
            <tr :key="'evidence-service-' + index">
                <td
                  :key="'evidence-service-col-1-' + index"
                  class="align-middle pl-4">
                    {{ service.service_name }}<br>
                    <small><strong>{{ $t('ui.code')}}:</strong> {{ service.service_code }}</small>
                </td>
                <td
                  :key="'evidence-service-col-2-' + index"
                  class="align-middle">
                    {{ service.quantity }} {{ $t('ui.piecesAbbr') }}
                </td>
                <td
                  :key="'evidence-service-col-3-' + index"
                  class="align-middle">
                    {{ service.price }} {{ currencySymbol }} {{ $t('ui.perUnit') }}<br>
                    {{ service.price_setup }} {{ currencySymbol }} ({{ $t('service.setup') }})<br>
                    {{ $t('service.fromHowManyPiecesThePriceIsMultiplied') }}: {{ service.content.price_multiple_from }} {{ $t('ui.piecesAbbr') }}
                </td>
            </tr>
          </template>
        </tbody>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'order-evidence-popup',
  props: [
    'evidenceData'
  ],
  computed: {
    currencySymbol () {
      return this.evidenceData.content.currency_code;
    },
    globalServices () {
      return this.servicesInProduct(0);
    }
  },
  methods: {
    handleClose () {
      this.$bus.$emit('close-order-evidence-popup');
    },
    servicesInProduct (productOrderID) {
      return this.evidenceData.services.filter(service => service.order_product_id === productOrderID);
    }
  }
}
</script>
